<template>
  <div class="wjAppointmentEdit1">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回审核列表</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="送达日期" prop="driverSubServiceTime">
          <el-input type="text" v-model="ruleForm.driverSubServiceTime" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="司机姓名" prop="driverName">
          <el-input type="text" v-model="ruleForm.driverName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="司机手机" prop="driverPhone">
          <el-input type="text" v-model="ruleForm.driverPhone" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="司机身份证号" prop="driverIdCard">
          <el-input type="text" v-model="ruleForm.driverIdCard" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="车牌号码" prop="driverCarNum">
          <el-input type="text" v-model="ruleForm.driverCarNum" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="物品简介" prop="driverGoodsInfo">
          <el-input type="text" v-model="ruleForm.driverGoodsInfo" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="同行人员姓名" prop="driverTogetherName" v-if="ruleForm.driverTogetherName">
          <el-input type="text" v-model="ruleForm.driverTogetherName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="同行人员手机" prop="driverTogetherPhone" v-if="ruleForm.driverTogetherPhone">
          <el-input type="text" v-model="ruleForm.driverTogetherPhone" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="同行人员身份证号" prop="driverTogetherIdCard" v-if="ruleForm.driverTogetherIdCard">
          <el-input type="text" v-model="ruleForm.driverTogetherIdCard" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="接收人姓名" prop="driverReceiveName">
          <el-input type="text" v-model="ruleForm.driverReceiveName" disabled class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="接收人电话" prop="driverReceivePhone">
          <el-input type="text" v-model="ruleForm.driverReceivePhone" disabled class="item-input"></el-input>
        </el-form-item>
        <!-- <el-form-item tem label="核酸检测证明" prop="fj2" v-if="ruleForm.fj2">
          <viewer :images="this.ruleForm.fj2">
            <img v-for="(src,index) in this.ruleForm.fj2" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>

        </el-form-item> -->
        <!-- <el-form-item tem label="辽事通健康码" prop="fj21" v-if="ruleForm.fj21">
          <viewer :images="this.ruleForm.fj21">
            <img v-for="(src,index) in this.ruleForm.fj21" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>
        </el-form-item> -->
        <!-- <el-form-item tem label="大数据行程码" prop="fj22" v-if="ruleForm.fj22">
          <viewer :images="this.ruleForm.fj22">
            <img v-for="(src,index) in this.ruleForm.fj22" :src="src" :key="index"
              style="width: 100px; height: 100px; margin-right: 20px;" />
          </viewer>
        </el-form-item> -->
        <!-- 按钮 -->
        <el-button class="btn-first" type="danger" @click="showdialog()"
          :disabled="ruleForm.state==2||ruleForm.state==3">拒绝</el-button>
        <el-button class="detailbtn" type="primary" @click="adopt()" :disabled="ruleForm.state==2||ruleForm.state==3">通过
        </el-button>
      </el-form>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <el-input rows=4 type="textarea" v-model="refuseReason" placeholder="请输入拒绝原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="refuse()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:wjAppointmentEdit1
   *@Description:万洁预约审批详情
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        ruleForm: {},
        dialogVisible: false, // 拒绝弹框
        refuseReason: '', // 拒绝原因
      }
    },
    computed: {
      ...mapGetters(['gardenId']),
    },
    created() {
      this.getData()
    },
    watch: {

    },
    methods: {

      // 业主通知编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        this.ruleForm = this.$route.query.object
        // this.ruleForm.fj2 = this.ruleForm.fj2.split(',')
        // this.ruleForm.fj21 = this.ruleForm.fj21.split(',')
        // this.ruleForm.fj22 = this.ruleForm.fj22.split(',')
        console.log(this.ruleForm)
      },
      // 审核通过
      adopt() {
        let loading = this.$loading()
        let params = {
          state: 2
        }
        this.$confirm('通过该货物配送申请？', '提示', {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'success'
          }).then(() => {
            this.$patch(`/wjSubscribe/${this.ruleForm.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  console.log(res)
                  this.$message({
                    type: 'success',
                    message: '已通过审批'
                  })
                  this.$router.push({
                    name: 'wjAppointmentExamine'
                  })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: '已取消审批'
            })
          })
      },
      // 审核不通过
      refuse() {
        if (this.refuseReason == '') {
          this.$message({
            type: 'info',
            message: '请输入拒绝原因'
          })
        } else {
          let loading = this.$loading()
          let params = {
            state: 3,
            checkInfo: this.refuseReason
          }
          this.$patch(`/wjSubscribe/${this.ruleForm.id}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.dialogVisible = false
                this.$message({
                  type: 'error',
                  message: '已拒绝审批'
                })
                this.$router.push({
                  name: 'wjAppointmentExamine'
                })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            })
        }
      },
      // 显示拒绝弹窗
      showdialog() {
        this.dialogVisible = true
      },
      // 返回上一级
      back() {
        // this.$router.push({
        //   name: 'wjAppointmentExamine'
        // })
        this.$router.back()
      },

    },
  }
</script>

<style lang="scss">
  .wjAppointmentEdit1 {
    .item-input {
      width: 30%;
    }

    .el-input.is-disabled .el-input__inner {
      color: #000;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block;
    }

    .empty-input {
      display: none;
    }

    .el-textarea.is-disabled .el-textarea__inner {
      color: #000;
    }
  }
</style>